import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse, Divider, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { BREEZE_SCORE_WEIGHTS } from "../../../../utils/constants";
import ChipColor from "../../../remediation/plan/components/ChipColor";
import { logos } from "../../../stack/environment/icons/iconExport";
import { mapBreezeScoreToSeverity } from "../VulnerabilitiesTable";
import RowInBreezeScore from "./RowInBreezeScore";

const BreezeScore = ({ selectedVulnerability }) => {
  const colors = useColors();
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      sx={{
        alignItems: "center",
        alignSelf: "stretch",
        backgroundColor: "white",
        borderRadius: "10px",
        border: "1px solid " + colors.legend_separator,
        padding: 1,
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={1}
        sx={{ width: "100%" }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
          gap={1}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={3}
            sx={{ padding: 1 }}
          >
            <Box display={"flex"} alignItems={"center"} gap={1}>
              <SvgToIcon IconLogo={logos.BreezeLogo} width={"18px"} />
              <Typography variant="subtitle1">
                Breeze Score Breakdown
              </Typography>
            </Box>
            <ChipColor
              value={selectedVulnerability?.breeze_score?.total?.toFixed(1)}
              type={"vulnerabilitySeverity"}
              keyMapping={mapBreezeScoreToSeverity}
              useValueAsLabel={true}
              width={56}
            />
          </Box>
          <IconButton onClick={handleToggle}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            sx={{ paddingLeft: 1, paddingRight: 1, paddingBottom: 1 }}
          >
            <Divider orientation="horizontal" />

            <RowInBreezeScore
              rowScore={selectedVulnerability?.breeze_score?.scenarios}
              name={"Scenarios Risk"}
              weight={BREEZE_SCORE_WEIGHTS.SCENARIOS}
              tooltipText="Shows the risk of vulnerable entities involved in attack paths. Higher percentages indicate greater involvement in more scenarios."
            />
            <RowInBreezeScore
              rowScore={selectedVulnerability?.breeze_score?.controls}
              name={"Compensating Controls"}
              weight={BREEZE_SCORE_WEIGHTS.COMPENSATING_CONTROLS}
              tooltipText="Shows the percentage of non-compliant controls out of the total applicable controls. Higher percentages mean there are more gaps."
            />
            <RowInBreezeScore
              rowScore={selectedVulnerability?.breeze_score?.other}
              name={"Other sources"}
              weight={BREEZE_SCORE_WEIGHTS.OTHER_SOURCES}
              tooltipText="Shows the average score from CVSS and CSPM tool ratings."
            />
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default BreezeScore;
